/**
 * Data Provider configuration.
 *
 * Environment variables (set in .env or build env):
 *  VITE_PMS_API_ENDPOINT  – Base URL for the PMS REST API
 *  VITE_WP_API_KEY        – Optional bearer token for authenticated requests
 *  VITE_PMS_SITE_ID       – Site identifier sent as X-PMS-Site-ID header on every request
 *  VITE_PMS_AUTH_USER     – Basic Auth username
 *  VITE_PMS_AUTH_KEY      – Basic Auth password
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

export const PMS_API_ENDPOINT: string =
  (import.meta.env.VITE_PMS_API_ENDPOINT as string) ||
  `${SUPABASE_URL}/functions/v1/pms-proxy`;

export const WP_API_KEY: string | undefined =
  import.meta.env.VITE_WP_API_KEY as string | undefined;

/** Basic Auth credentials for PMS REST API */
export const PMS_AUTH_USER: string | undefined =
  import.meta.env.VITE_PMS_AUTH_USER as string | undefined;

export const PMS_AUTH_KEY: string | undefined =
  import.meta.env.VITE_PMS_AUTH_KEY as string | undefined;

/** Site identifier sent as X-PMS-Site-ID on every API request */
export const PMS_SITE_ID: string | undefined =
  import.meta.env.VITE_PMS_SITE_ID as string | undefined;

/** Feature flag: set to false to skip WP entirely and use Supabase only */
export const WP_ENABLED: boolean =
  (import.meta.env.VITE_WP_ENABLED as string ?? 'true') === 'true';
